import { atom } from 'recoil';
import { v4 } from 'uuid';
import { recordBackendSessionId } from '~/utils/error-diagnostics';
const DEFAULT_SESSION_ID_PREFIX = 'rtviewer3';

const STATIC_SESSION_ID = import.meta.env.VITE_STATIC_SESSION_ID;

const INITIAL_SESSION_ID: string = STATIC_SESSION_ID ?? generateSessionId();
recordBackendSessionId(INITIAL_SESSION_ID);

export const sessionIDState = atom<string>({
    key: 'sessionIDState',
    default: INITIAL_SESSION_ID,
    effects: [
        // Keep the error page and Sentry tag in sync with session resets.
        ({ onSet }) => onSet((sessionId) => recordBackendSessionId(sessionId)),
    ],
});

export function generateSessionId(): string {
    const uuid = v4().replaceAll('-', '');
    return `${DEFAULT_SESSION_ID_PREFIX}.${uuid}`;
}
